import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { LockOutlined, ToolOutlined } from '@ant-design/icons';

// Màn hình thay nội dung bài khi module chưa học được:
// - MODULE_UNDER_CONSTRUCTION: module chưa có nội dung
// - MODULE_LOCKED: chưa đạt bài test module trước trong cùng chủ đề (details.blockedBy)
export function ModuleGateNotice({ code, message, details }) {
  const navigate = useNavigate();
  const blockedBy = details?.blockedBy;
  const isBuilding = code === 'MODULE_UNDER_CONSTRUCTION';

  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <Result
        icon={isBuilding ? <ToolOutlined style={{ color: '#0284c7' }} /> : <LockOutlined style={{ color: '#f59e0b' }} />}
        title={isBuilding ? 'Module đang trong giai đoạn xây dựng' : 'Module chưa mở'}
        subTitle={
          isBuilding
            ? 'Đội ngũ Thế Thảo Pharma đang biên soạn nội dung module này. Anh/chị học các module đã có trước, module này sẽ mở ngay khi hoàn thiện.'
            : message || 'Anh/chị cần làm đạt bài test của module trước (trên 5/10 điểm) để mở module này.'
        }
        extra={[
          !isBuilding && blockedBy?.id && (
            <Button
              key="prev"
              type="primary"
              style={{ background: '#005537', borderColor: '#005537' }}
              onClick={() => navigate(`/learn/${blockedBy.courseId}/lessons/${blockedBy.id}`)}
            >
              Học tiếp module {blockedBy.code}
            </Button>
          ),
          <Button key="back" onClick={() => navigate('/courses')}>
            Về danh sách chuyên đề
          </Button>,
        ].filter(Boolean)}
      />
    </div>
  );
}
